export default "__VITE_ASSET__CO3Jp1ag__"